var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("embed_responsive embed_responsive--" + _vm.aspectRatio)},[_c('iframe',{class:("embed_responsive__item " + _vm.extraClass),attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }